import Swiper, {Controller, Navigation, Pagination} from 'swiper';

const galleries = [...document.querySelectorAll('.j-swiper-gallery')];

galleries.forEach((gallery) => {
    const gallerySlidesCount = gallery.querySelectorAll('.j-caption-slider__slide').length;
    const captionSliderWrapper = gallery.querySelector('.j-caption-slider');
    let captionSlider = null;

    if (captionSliderWrapper) {
        captionSlider = new Swiper(captionSliderWrapper, {
            modules         : [Controller],
            wrapperClass    : 'j-caption-slider__wrapper',
            slideClass      : 'j-caption-slider__slide',
            slidePrevClass  : 'is-prev',
            slideActiveClass: 'is-active',
            slideNextClass  : 'is-next',
            loop            : true,
            slidesPerView   : 1
        });
    }

    const slider = new Swiper(gallery, {
        modules         : [Controller, Navigation, Pagination],
        wrapperClass    : 'j-swiper-gallery__wrapper',
        slideClass      : 'j-swiper-gallery__slide',
        slidePrevClass  : 'is-prev',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 1,
        loop            : gallerySlidesCount > 1,
        pagination      : {
            el               : gallery.querySelector('.j-swiper-gallery__pagination'),
            bulletClass      : 'fullsize-slider__bullet',
            bulletActiveClass: 'is-active',
            clickable        : true,
            enabled          : gallerySlidesCount > 1
        },
        navigation: {
            nextEl : '.j-swiper-gallery__next',
            prevEl : '.j-swiper-gallery__prev',
            enabled: gallerySlidesCount > 1
        }
    });

    if (captionSliderWrapper && captionSlider) {
        captionSlider.controller.control = slider;
        slider.controller.control = captionSlider;
    }

    if (gallerySlidesCount < 2) {
        slider.el.querySelectorAll('.button-slider').forEach((button) => {
            button.style.display = 'none';
        });
    }
});
